import * as angular from 'angular';
import {makeSelectables} from '../../administrators/make-selectables';

const dateFilter = angular.injector(['ng']).get('dateFilter');

export const policyFromDto = (policy, countries, browserTypes, osTypes) => {
    const {deviceAccessRuleDTO, locationAccessRuleDTO, timezoneOffset} = policy;

    const selectableCountries = countries.map(name => ({id: name, name}));
    const trustedCountries = makeSelectables(locationAccessRuleDTO.trustedCountryNames, selectableCountries);
    const notTrustedCountries = makeSelectables(locationAccessRuleDTO.notTrustedCountryNames, selectableCountries);

    const selectableBrowsers = browserTypes.map(name => ({id: name, name}));
    const browsers = makeSelectables(deviceAccessRuleDTO.browsers, selectableBrowsers);

    const selectableOSes = osTypes.map(name => ({id: name, name}));
    const oses = makeSelectables(deviceAccessRuleDTO.allowedOperatingSystemList, selectableOSes);

    const hours = Math.floor(timezoneOffset / 60);
    const mins = timezoneOffset - hours * 60;
    const gmtOffset = {hours, mins};

    const hasTimeAccessRules = policy.timeAccessRules.length !== 0;

    const findRule = dayOfWeek => policy.timeAccessRules.find(r => r.dayOfWeek === dayOfWeek);
    const newRule = dayOfWeek => ({isNew: true, startTime: '00:00', endTime: '23:59', dayOfWeek});

    const timeAccessRules = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
        .map(dayOfWeek => findRule(dayOfWeek) || newRule(dayOfWeek))
        .map(rule => ({
            isSelected: !rule.isNew,
            startTime: new Date(`1970-01-01 ${rule.startTime}`),
            endTime: new Date(`1970-01-01 ${rule.endTime}`),
            dayOfWeek: rule.dayOfWeek,
        }));

    return {
        id: policy.id,
        policyName: policy.policyName,
        deviceAccessRuleDTO: {...deviceAccessRuleDTO},
        locationAccessRuleDTO: {...locationAccessRuleDTO},
        browsers,
        gmtOffset,
        hasTimeAccessRules,
        notTrustedCountries,
        oses,
        timeAccessRules,
        trustedCountries,
    };
};

export const policyToDto = (policy, countries, browserTypes, osTypes) => ({
    id: policy.id,
    policyName: policy.policyName,
    deviceAccessRuleDTO: {
        ...policy.deviceAccessRuleDTO,
        browsers: policy.browsers.isAllSelected() ? browserTypes : policy.browsers.getSelectedIds(),
        allowedOperatingSystemList: policy.oses.isAllSelected() ? osTypes : policy.oses.getSelectedIds(),
    },
    locationAccessRuleDTO: {
        ...policy.locationAccessRuleDTO,
        trustedCountryNames: policy.trustedCountries.isAllSelected()
            ? countries
            : policy.trustedCountries.getSelectedIds(),
        notTrustedCountryNames: policy.notTrustedCountries.isAllSelected()
            ? countries
            : policy.notTrustedCountries.getSelectedIds(),
    },
    timeAccessRules: policy.hasTimeAccessRules
        ? policy.timeAccessRules
              .filter(r => r.isSelected)
              .map(r => ({
                  dayOfWeek: r.dayOfWeek,
                  startTime: dateFilter(r.startTime, 'HH:mm'),
                  endTime: dateFilter(r.endTime, 'HH:mm'),
              }))
        : [],
    timezoneOffset: policy.gmtOffset.hours * 60 + policy.gmtOffset.mins,
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/AuthenticationAccessPolicyDTO.js